<div class="CurrentDate d-flex justify-content-center">{{CurrentDate}}</div>
